import React from 'react';
import { useUI } from '../context/UIContext';
import { View } from '../types';
import { CyzorHome } from '../components/home/CyzorHome';
import PulseView from '../components/PulseView';
import PlanejamentoEstrategicoView from '../components/PlanejamentoEstrategicoView';
import EmpresasView from '../components/EmpresasView';
import ClientesView from '../components/ClientesView';
import ClienteWorkspaceView from '../components/ClienteWorkspaceView';
import ProdutosView from '../components/ProdutosView';
import ProdutoWorkspaceView from '../components/ProdutoWorkspaceView';
import ProjetosView from '../components/ProjetosView';
import ProjetoWorkspaceView from '../components/ProjetoWorkspaceView';
import IdeiasView from '../components/IdeiasView';
import FinanceiroView from '../components/FinanceiroView';
import DocumentacaoView from '../components/DocumentacaoView';
import IAView from '../components/IAView';
import AgendaPage from '../agenda/pages/AgendaPage';
import GoogleKeepView from '../components/GoogleKeepView';
import VisualSystemsStudioView from '../modules/VisualSystemsStudio/VisualSystemsStudioView';
import ConfiguracoesView from '../components/ConfiguracoesView';
import EquipeView from '../components/EquipeView';
import MembroWorkspaceView from '../components/MembroWorkspaceView';
import IdeiaWorkspaceView from '../components/IdeiaWorkspaceView';
import UserProfileView from '../components/UserProfileView';
import SettingsPage from '../pages/SettingsPage';

interface LegacyViewRendererProps {
  currentView: View | 'admin';
}

export function LegacyViewRenderer({ currentView }: LegacyViewRendererProps) {
  const { setCurrentView } = useUI();
  if (currentView === 'dashboard') return <CyzorHome />;
  if (currentView === 'pulse') return <PulseView />;
  if (currentView === 'roadmap') return <PlanejamentoEstrategicoView setCurrentView={setCurrentView} />;
  if (currentView === 'empresas') return <EmpresasView />;
  if (currentView === 'clientes') return <ClientesView setCurrentView={setCurrentView} />;
  if (currentView === 'cliente-workspace') return <ClienteWorkspaceView setCurrentView={setCurrentView} />;
  if (currentView === 'produtos') return <ProdutosView />;
  if (currentView === 'produto-workspace') return <ProdutoWorkspaceView setCurrentView={setCurrentView} />;
  if (currentView === 'projetos') return <ProjetosView setCurrentView={setCurrentView} />;
  if (currentView === 'projeto-workspace') return <ProjetoWorkspaceView setCurrentView={setCurrentView} />;
  if (currentView === 'ideias') return <IdeiasView />;
  if (currentView === 'financeiro') return <FinanceiroView />;
  if (currentView === 'documentacao') return <DocumentacaoView />;
  if (currentView === 'ia') return <IAView setCurrentView={setCurrentView} />;
  if (currentView === 'agenda') return <AgendaPage />;
  if (currentView === 'keep') return <GoogleKeepView />;
  if (currentView === 'flow-builder') return <VisualSystemsStudioView />;
  if (currentView === 'configuracoes') return <ConfiguracoesView />;
  if (currentView === 'equipe') return <EquipeView />;
  if (currentView === 'membro-workspace') return <MembroWorkspaceView setCurrentView={setCurrentView} />;
  if (currentView === 'ideia-workspace') return <IdeiaWorkspaceView setCurrentView={setCurrentView} />;
  if (currentView === 'perfil') return <UserProfileView setCurrentView={setCurrentView} />;
  if (String(currentView) === 'neural-settings') return <SettingsPage />;
  return <CyzorHome />;
}
